import { whatIfInnerSelector } from '../../WhatIfsSelector';

export const purchasePriceSelector = (state, props) =>
  whatIfInnerSelector(state, props).Price;

export default null;
